<template>
  <div>
    <DocumentSelection
      :selected-documents="documents"
      removable
      @remove="$emit('remove', $event)"
    />
    <v-divider class="my-6" />
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'

import DocumentSelection from '@/common/document-selection/DocumentSelection.vue'

/**
 * The documents the table pane was opened on, shown above the content of whichever tab is
 * active. AppDrawer drives its body through one slot per tab, so the reminder is rendered by
 * each of them rather than once above the tab bar, and this component keeps that repetition
 * down to a single line per tab.
 *
 * @displayName DocumentsTablePaneSelection
 */
export default defineComponent({
  name: 'DocumentsTablePaneSelection',
  components: { DocumentSelection },
  props: {
    /**
     * Documents currently selected in the table
     */
    documents: {
      type: Array as PropType<unknown[]>,
      default: () => [],
    },
  },
  emits: ['remove'],
})
</script>
